
import React from "react";
/** Components */
import InvoiceSupplier from '../../components/InvoiceSupplier/InvoiceSupplier';
import SupplierWrapper from '../../components/SupplierWrapper';


export default (props) => {
  const supplierId = props.match.params.id;
  return (

    <SupplierWrapper {...props}>
      <InvoiceSupplier supplierId={supplierId} defaultFilter={{supplierId}} />
    </SupplierWrapper>

  );

}

